<template>
  <div class="grid-columns grid-spacing grid-gutters grid">
    <slot />
  </div>
</template>
